export class LikeService {
  constructor($http) {
    this.http = $http;
  }

  getUniqNum() {
    return (String(Math.random()).toString()).replace("0.", "");
  }

  getLikeCounters(id){
    return this.http.get(`/api/like/counters/${id}/1/100?${this.getUniqNum()}`)
  }

  getMutualUsers(page, limit) {
    return this.http.get("/api/like/mutual/" + page + "/" + limit);
  }

  interestedInYouLikesReceiver(page, limit, params) {
    return this.http.post("/api/like/receiver/" + page + "/" + limit, params);
  }

  interestedInYouLikesCheck(params) {
    return this.http.post("/api/like/check/", params);
  }

  getInterestLikeReceiver(page, limit) {
    return this.http.get("/api/like/giver/" + page+ "/" +limit);
  }

  isAllLiked(users) {
    return this.http.post("/api/like/isAllLiked/?" + this.getUniqNum(), users);
  }

  isMutualLiked(id1, id2) {
    return this.http.post("/api/like/ismutual", { id1 : id1, id2: id2 });
  }
}
